import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'firstUppercase' })
export class FirstUpperCasePipe implements PipeTransform {
  transform(text: string): string {
    return text ? text[0].toUpperCase() + text.substring(1) : '';
  }
}
